/*
 * a class specifically for EP UI handling
 */
import ChatUIController from '../core/ChatUIController';
import WidgetTypes from '../core/enums/WidgetTypes';
import TempCache from '../core/enums/TempCache';
import ParticipantIds from '../core/enums/ParticipantIds';
//import FancyDropdown from '../core/FancyDropdown';
import UserIds from '../core/hooks/UserIds';
import { ScriptsQuestionType } from '../core/enums/Enum';
import GlobalVariables from '../core/GlobalVariables';
import GetChatID from '../core/hooks/GetChatID';
import AgentImageHandler from '../core/hooks/AgentImageHandler';
import RunAsSoonAs from '../core/hooks/RunAsSoonAs';
import isEnterKeyPressed from '../core/hooks/isEnterKeyPressed';
import Cookies from '../core/hooks/Cookies';
import WidgetStates from '../core/hooks/WidgetStates';
import logIt from '../../logIt';
import Transcriber from '../core/hooks/speechToText/Transcriber';
export default class EPUIController extends ChatUIController {
    constructor(options) {
        const opt = options;
        Object.assign(opt.elements, {
            textboxSelector: '.apex-input',
            // containerSelector: '.apex-popup-container',
            // minimizeSelector: '#apexchat-ep-minimize',
            agentTitle: '.apex-profile-usertitle', // participantsSelector
            clickSourceId: '.apex-powerdby',
            messagesContainerSelector: '.apex-transcript',
            typingIndicatorSelector: '.apex-agent',
            autoCompleteInput: '#apexchat #txtAutocompleteInput',
            // minimizeSelector: '.apex-ep-minimizestate',
            maximizeState: '.apex-ep-maximizestate',
            closeSelector: '.apex-popup-close',
            handlerImageSelector: '.Apex-agentImage',
            minimizedImage: '.apex-img-minimized-invite',
            companyTitle: '.apex-company-title',
            clicktoStart: '.apex-start-chat',
            minimizePoweredBy: '.apex-powerdby-minimized',
            popoutSelector: '.apex-ep-openpopup',
            clickSelector: '.apex-btn',
            soundControl: '.apex-msg-notification',
            soundMute: '.apex-sound-mute',
            soundUnmute: '.apex-sound-unmute',
            regionEditorContainer: '#apexchat_exitpopup_region_container',
            regionEditorContainerWrapper: `#${options.model.exitPopupRegionEditorContainerId}`,
            multiLanguage_dropdown_wrapperSelector: '.apexchat_ep_multilang_wrapper',
            multiLanguage_dropdown_container: 'apexchat_ep_multilang_dropdown_container',
            multiLanguage_dropdown_select: 'apexchat_ep_multilang_dropdown',
            inputContainerSelector: '.apex-msg-type',
            actionMenuStartSMSChat: '.switchto-text-chat',
            smsBottomSheetClose: '#livechat_bottom_sheet_sms_close'
        });
        opt.widget = WidgetTypes.EPUIController;
        opt.objectType = WidgetTypes.EPUIController;
        super(opt);
        this.mode = WidgetTypes.ExitPopup;
        this.chatStarted = false;
        // other availablity check from portal
        const isVoiceToTextEnabled = this.options.model && this.options.model.speechToTextEnabled;
        const me = this;
        if (!ApexChat.transcriber && isVoiceToTextEnabled) {
            ApexChat.transcriber = new Transcriber({
                context: me.context,
                elements: me.options.elements || {}
            });
        }
    }

    bind(state) {
        const me = this;
        if (state !== WidgetStates.ShownMinimized) {
            super.bind();
        }
        // me.$(me.options.elements.containerSelector, me.context).removeClass('apex-container-fix').show().css({
        //  'top': null, 'left': null
        // });
        if (!me.options.model.headerDisclaimer || me.options.model.headerDisclaimer.trim() == '') {
            // Added .trim() So if someone used 'Blank Spaces' this condition will catch it and will not show the header disclaimer
            me.$('.apexchat_ep_rd_additionalHeaderDisclaimer', me.context).hide();
        }
        me.$(me.options.elements.closeSelector, me.context).click(() => {
            ApexChat.preLoadedOptions = null; // dispense with it as DOM should load it on tis own - Zee
            // me.state.changeState({ origin: WidgetTypes.ExitPopup, toState: WidgetStates.Hidden });
        });
        me.$('#apexchat-ep', me.context).on('click', () => {
            me.$(me.options.elements.actionMenuSelector, me.context).hide();
        });
        if (!ApexChat.IsRoundedDynamicPlusTheme) {
            // finally, apply extra logic when shown
            me.$(me.options.elements.clickSourceId, me.context).html(me.options.model.poweredBy);
            me.$(me.options.elements.companyTitle, me.context).html(
                me.options.model.exitPopupChat.chatTitle
            );
            // handlerImageUrl should be coming from what was assigned in widgetbase.js
            me.$(me.options.elements.handlerImageSelector, me.context).attr(
                'src',
                AgentImageHandler(me.options.model.handlerImageUrl)
            );
            me.$(me.options.elements.agentTitle, me.context).html(me.options.model.agentName);
        }
        me.hideOnlineAgent(); // CHAT-8631 check Enable Generic Aliasing handler is enabled and also scriptbot enabled then hide online tag.
    }

    hideOnlineAgent() {
        const me = this;
        const onlineAgentText = me.$(me.options.elements.agentOnlineText, me.context);
        const checkgenericHandlerScriptBot =
            me.options.model &&
            me.options.model.genericHandlerAliasingEnabled &&
            me.options.model.scriptBotEnabled &&
            onlineAgentText;
        if (checkgenericHandlerScriptBot) {
            onlineAgentText.hide();
        }
    }

    invokeKeyDown(e) {
        const me = this;
        // var e = jQuery.Event('keydown', { which: $.ui.keyCode.ENTER });
        // $(me.options.elements.textboxSelector).trigger(e);
        // var el = $(me.options.elements.textboxSelector, me.context);

        // $(me.options.elements.textboxSelector, me.context).keydown(e);
    }

    loadChatRoom(cb) {
        super.loadChatRoom(cb);
    }

    show(state) {
        const me = this;
        super.show(state);
        const isPageRefreshed = this.isPageRefreshed();
        if (ApexChat.options.exitpopup.chatbotGreetingMessages) {
            var script = structuredClone(ApexChat.options.exitpopup.chatbotGreetingMessages[0]);
            ApexChat.options.exitpopup.chatbotGreetingMessages[0].agentScript = script
            delete ApexChat.options.exitpopup.chatbotGreetingMessages[0].agentScript.agentScript
            ApexChat.options.exitpopup.chatbotGreetingMessages[0].agentScript.options = JSON.stringify(ApexChat.options.exitpopup.chatbotGreetingMessages[0].agentScript.options)

            ApexChat.options.exitpopup.chatbotGreetingMessages[0].agentScript.agentScriptOptions = JSON.stringify(ApexChat.options.exitpopup.chatbotGreetingMessages[0].agentScript.options)
            ApexChat.options.exitpopup.exitPopupMessages = ApexChat.options.exitpopup.chatbotGreetingMessages
        }
        const { exitPopupMessages } = ApexChat.options.exitpopup;
        exitPopupMessages.forEach(function (msg) {
            msg.message = me.fixDataBinding(msg.message);
        });
        if (!isPageRefreshed && state == WidgetStates.ShownMaximized) {
            if (exitPopupMessages.length > 0) {
                me.queuePredefinedQTs();
            } else {
                me.renderPredefinedMessages();
            }
            // appointment scheduler is set a predined QT then make chat room alive
            if (
                exitPopupMessages.length > 0 &&
                exitPopupMessages[0].questionType ==
                ScriptsQuestionType.AppointmentScheduler &&
                !me.isChatActive()
            ) {
                me.bindAppointmenSchedulePredefined.call(me);
            }
        }
        // Render predefined messages in page referesh case
        if (
            isPageRefreshed &&
            state === WidgetStates.ShownMaximized &&
            exitPopupMessages.length > 0 &&
            exitPopupMessages[0].questionType ==
            ScriptsQuestionType.AppointmentScheduler &&
            me.isChatActive()
        ) {
            if (exitPopupMessages.length > 0) {
                me.queuePredefinedQTs({ isPageRefreshed });
            } else {
                me.renderPredefinedMessages(isPageRefreshed);
            }
        }
        if (
            isPageRefreshed &&
            state === WidgetStates.ShownMaximized &&
            !me.isChatActive()
        ) {
            if (exitPopupMessages.length > 0) {
                me.queuePredefinedQTs({ isPageRefreshed });
            } else {
                me.renderPredefinedMessages(isPageRefreshed);
            }
        }
        // apply any css/html tweak here - optional
    }

    hide() {
        // ToDo: we need to implement this destroy functionality for other types as well.
        const me = this;
        // also dispens with all resources: nullify objects and remove event subscriptions
        me.questionTypeRenderer = null;
        me.clearAllSubscriptions();
    }

    pop() {
        super.pop();
    }

    end() {
        this.hide(); // now we want EP to just hide/close w/o ending the active chat
        this.state.changeState({
            origin: WidgetTypes.ExitPopup,
            toState: WidgetStates.Closed
        });
        const prechatWrapper = document.getElementById("apexchat_prechat_invitation_wrapper");
        prechatWrapper.classList.remove('hide-prechat-on-video-greet')
    }

    endChat() {
        const me = this;
        super.endChat();
        ApexChat.storageAPI.StoreTemp('livechat_exitpopup_is_closed', true);
    }

    endChatSession() {
        super.endChatSession();
        const me = this;

        me.state.changeState({
            origin: WidgetTypes.ExitPopup,
            toState: WidgetStates.Closed
        });
    }

    renderPredefinedMessages(isPageRefreshed) {
        ApexChat.storageAPI.Remove(TempCache.APEXCHAT_PRECHAT_MESSAGE_IDS_COOKIE); // JIRA_4341 - Pre-Chat message shouldn't append in EP
        super.renderPredefinedMessages({
            text: '',
            participantDisplayName: this.options.model.agentName,
            id: -2,
            userId: TempCache.EP_PREDEFINED_AGENT_ID,
            createdOn: new Date(),
            isPredefinedMsg: true,
            isPageRefreshed
        });
    }

    queuePredefinedQTs(isPageRefreshed) {
        ApexChat.storageAPI.Remove(TempCache.APEXCHAT_PRECHAT_MESSAGE_IDS_COOKIE); // JIRA_4341 - Pre-Chat message shouldn't append in EP
        super.queuePredefinedQTs({
            text: '',
            participantDisplayName: this.options.model.agentName,
            id: -2,
            userId: TempCache.EP_PREDEFINED_AGENT_ID,
            createdOn: new Date(),
            isPredefinedMsg: true,
            isPageRefreshed
        });
    }

    renderMultiLanguageDropDown(config) {
        super.renderMultiLanguageDropDown(config);
    }

    implementMultiLanguageSupport(config) {
        const me = this;
        if (!me.options.model.showMultiLangDropDown || me.nonSMSLanguages.length <= 1) {
            me.multiLanguage_dropdown_wrapper.style.display = 'none';
            return;
        }
        // FancyDropdown({
        //     context: me.context,
        //     containerId: config.containerId, // Container ID of container in which dropdown exist.
        //     dropdownId: config.dropdownId, // dropdown ID
        //     model: me.nonSMSLanguages, // Data model which should contain value and text which you wanna render
        //     value: 'threeLetterISOLanguageName', // In your Data model the specific property you wanna show for value field
        //     innerHTML: 'languageFullName', // In your Data model the specific property you wanna show for innerHTML Text field
        //     onSelect() {
        //         // on click of dropdown or selection.
        //         const multiLangDropDown = me.context.getElementById(config.dropdownId);
        //         me.chatLanguageName =
        //             multiLangDropDown.options[multiLangDropDown.selectedIndex].text;
        //         TempCache.chatLanguage = multiLangDropDown.value;
        //         me.requestTransferringChat(config);
        //     },
        //     onComplete() {
        //         // after render callback
        //         ApexChat.addClass(
        //             me.context.getElementsByClassName('apex-msg-notification')[0],
        //             'apex-msg-notification-with-multilang'
        //         );
        //         ApexChat.addClass(
        //             me.context.getElementsByClassName('apex-agent')[0],
        //             'apex-agent-with-multilang'
        //         );
        //         // Ref. CHAT-5206
        //         const soundIcon = me.context.getElementById('apex-msg-audio-notification');
        //         if (soundIcon) {
        //             soundIcon.style.cssText = 'top:-16px !important;';
        //         }
        //         const langSelect = me.context.getElementById(config.containerId);
        //         if (langSelect) {
        //             langSelect.style.cssText = 'left: auto !important;';
        //         }
        //     }
        // });
    }

    sendMessage(el) {
        const me = this;
        const text = me.$(el || me.messageInput, me.context);
        let v = text.val().trim();
        const isChatEnded = ApexChat.storageAPI.Get('livechat_exitpopup_is_closed');

        if (v == '' && me.messageInputText != '') {
            v = me.messageInputText;
            me.messageInputText = '';
        }
        if (!v || v.replace(/\s/g, '') === '' || v == text.attr('title')) {
            return;
        }
        const isPredefinedResponse = !me.firstMsgSent && !me.isChatroomAlive(); // no 1st msg sent and no chatroom, it's gotta be 1st response to the predef
        if (me.QTRendererExt && me.QTRendererExt.isLastMessageFullText()) {
            me.QTRendererExt.validateFullTextMessage(v, {
                isPredefinedResponse
            }); // just validate and return
            return; // we are separately handling Fulltext scenario in handleFullTextType()
        }
        if (!me.firstMsgSent) {
            // cache the upfront 1st predef response by visitor to be sent along with predef below
            me.preserveChatArray.push({
                index: me.preserveChatArray.length + 1,
                text: v,
                userId: ParticipantIds.visitor,
                isPredefinedResponse,
                createdOn: new Date(),
                participantDisplayName: 'Visitor',
                participantId: ParticipantIds.visitor,
                agentParticipantId: ParticipantIds.predefined
            });
        }
        // check chatroom alive, and push them as soon as it's available
        if (
            me.preserveChatArray.length > 0 &&
            me.options &&
            me.options.msg &&
            me.options.msg.questionType == ScriptsQuestionType.AppointmentScheduler &&
            me.isChatroomAlive()
        ) {
            if (!me.isPreDefinedMessagesSent) {
                me.publishPredefinedMessages(() => {
                    me.preserveChatArray = []; // clear
                });
            }
        } else {
            // wait for a chatroom, and push them as soon as it's available
            if (me.preserveChatArray.length > 0) {
                RunAsSoonAs(
                    () => {
                        if (!me.isPreDefinedMessagesSent) {
                            me.publishPredefinedMessages(() => {
                                me.startWaiting();
                                me.room.sendLive();
                                me.preserveChatArray = []; // clear
                            });
                            me.showTyptingIndicatorForAIBot(me);
                        }
                    },
                    () => me.isChatroomAlive()
                );
                return; // for the v 1st msg bail out
            }
        }
        // for any subsequent messages
        super.sendMessage(v);
        if (me.QTRendererExt && me.QTRendererExt.isLastPhoneTypeValidated()) {
            // Do not empty the input field if phone number is invalid
            return;
        }
        text[0].value = '';
    }

    /**
     * overloaded version of onMessageTyping in widgetbase.js to write separate logic for EP
     * @param {any} e
     */
    onMessageTyping(e) {
        const me = this;
        const autoComplete = me.$(me.autoCompleteInput).is(':visible') ? me.$(me.autoCompleteInput) : null;
        try {
            me.isUserTyping = true;
            if (isEnterKeyPressed(e)) {
                // if (me.room && me.room.isConnectionEstablished) {//now that visitor can shoot a message w/o an active chat connection, we must not let onMessageTyping sendMessage
                logIt('EP::sending msg on typing');
                me.sendMessage(autoComplete);
                window.clearTimeout(me.timeout);
                me.typing = false;
                if (me.isChatroomAlive()) {
                    me.room.sendTyping(false);
                }
                e.preventDefault();
                // const text = [];
            } else if (me.room) {
                me.sendTyping(e);
            }
        } catch (ex) {
            console.log(ex.message);
        }
    }

    simulatePlainTextPredefinedResponse(msg) {
        const me = this;
        me.onMessageArrived({
            id: GlobalVariables.predefinedMessageId,
            userId: ParticipantIds.visitor,
            createdOn: new Date(),
            participantDisplayName: 'Visitor',
            text: msg.msgText,
            allowDupe: false,
            isFirstPredefinedMsgResponse: true,
            participantId: ParticipantIds.visitor,
            showTime: true // show time for simulated message
        });
    }

    resetCurrentEPState() {
        const me = this;
        Cookies.del('livechat_exitpopup_is_closed');
        me.state.changeState({
            origin: WidgetTypes.ExitPopup,
            toState: WidgetStates.ShownMaximized
        });
        ApexChat.storageAPI.Store(TempCache.IS_PAGE_REFRESHED, false);
    }

    startNewChatForEP() {
        const me = this;
        me.isUserTyping = false; // when new chat start user typing must be false
        me.room = null; // chat room should be null
        me.isPreDefinedMessagesSent = false; // assign false value when new chat start
        me.reInitializeChat();
        me.hideReInitOverlay('#apexchat_reinit_chat_ep');
    }

    showChatEndedNotificationEP() {
        const me = this;
        me.optInConsentTaken = false;
        const epReinitInner = me.$('#apexchat_reinit_chat_ep', me.context);
        const epReinitWrapper = epReinitInner.parent('.apexchat_reinit_chat_wrapper_ep');
        epReinitWrapper.addClass('livechat_reinit_show');
        epReinitInner.css('display', 'block');
        setTimeout(function () {
            epReinitInner.addClass('apexchat_optin_concent_show');
        });
        me.$('.apexchat_closebtn_ep', me.context).bind('click', () => {
            me.hideReInitOverlay('#apexchat_reinit_chat_ep');
            epReinitInner.removeClass('apexchat_optin_concent_show');
            epReinitWrapper.removeClass('livechat_reinit_show');
        });
        me.ADAHandler(
            me.context.querySelector('.apexchat_closebtn_ep'),
            me.hideReInitOverlay.bind2(me, '#apexchat_reinit_chat_ep')
        );
        me.ADAHandler(me.context.querySelector('.apexchat_new_chat_start_ep'), () => {
            me.startNewChatForEP();
            epReinitWrapper.removeClass('livechat_reinit_show');
        });
        me.$('.apexchat_new_chat_start_ep', me.context).bind('click', () => {
            me.startNewChatForEP();
            epReinitWrapper.removeClass('livechat_reinit_show');
        });
    }







    // because, EP's FT could occur as v 1st predef msg, so we want EP to override widgetbase's handleFullTextType to do custom/additional job of sending it
    handleFullTextType(options) {
        const me = this;
        // $txt = me.$(el || me.messageInput, me.context);
        const res = options && options.res;
        const cb = options && options.cb;
        const isPredefinedResponse = res && res.isPredefinedResponse;
        const isSkippable = res && res.isSkipped;
        if (isSkippable === true) {
            me.skipFullTextType(res);
            return;
        }
        // make sure Chat Is Active and In Progress before sending the message to Websync
        if (!me.QTRendererExt.isLastFullTextValidated) {
            return;
        }
        RunAsSoonAs(
            () => {
                const hasVisitorAttachments = !!me.fileUploader?.newValidFiles?.length ?? false;
                if (res && res.chatLogId && hasVisitorAttachments) {
                    me.fileUploader?.showTempFilesInMessage(res);
                }
                if (isPredefinedResponse) {
                    me.publishPredefinedMessages((m) => {
                        me.preserveChatArray = []; // clear
                        logIt('FT::sent');
                        me.room.sendMessage({
                            chatMsg: res.msgText,
                            isGreeting: res.isGreeting,
                            shouldRenderResponseAsText: true,
                            isPredefinedResponse,
                            questionTypeChatLogIdToBeUpdated: m.id,
                            async onSuccess(msg) {
                                // on success of websync publish
                                // if (isPredefinedResponse) {
                                res.chatLogId = m.id;
                                //   // res.questionTypeChatLogIdToBeUpdated = data.id;
                                // }
                                logIt('FT::publishing EP FT Pred...');
                                if (msg && msg.id && hasVisitorAttachments) {
                                    await me.fileUploader?.uploadFiles(msg);
                                }
                                me.room.publishQuestionTypeResponse(res, cb);
                            }
                        });
                    });
                }
                // logIt('FT::publishing FT res? ' + isPredefinedResponse);
                if (isPredefinedResponse) {
                    return;
                }
                me.room.sendMessage({
                    chatMsg: res.msgText,
                    isGreeting: res.isGreeting,
                    shouldRenderResponseAsText: true,
                    isPredefinedResponse,
                    questionTypeChatLogIdToBeUpdated: res.questionTypeChatLogIdToBeUpdated,
                    async onSuccess(msg) {
                        // on success of websync publish
                        logIt('FT::publishing DOM/EP FT...');
                        if (msg && msg.id && hasVisitorAttachments) {
                            await me.fileUploader?.uploadFiles(msg);
                        }
                        me.room.publishQuestionTypeResponse(res, cb);
                    }
                });
                if (me.autoCompleteInput) {
                    me.autoCompleteInput.value = ''; // clear text area when response submitted
                }
            },
            () =>
                // logIt('FT::handleFullTextType waiting for chatrrom connection...');
                me.isChatroomAlive() == true
        );
    }
    fixDataBinding(dataBindingTerm) {
        // FogBugs [2292] - START - Agent name and company name should be picked up dynamically as in classical widget.
        if (
            dataBindingTerm.indexOf('<#=companyName#>') !== -1 ||
            dataBindingTerm.indexOf('&lt;#=companyName#&gt;') !== -1
        ) {
            dataBindingTerm = dataBindingTerm
                .replace(/<#=companyName#>/g, this.options.model.companyName)
                .replace(/&lt;#=companyName#&gt;/g, this.options.model.companyName);
        }
        if (
            dataBindingTerm.indexOf('<#=agentName#>') !== -1 ||
            dataBindingTerm.indexOf('&lt;#=agentName#&gt;') !== -1
        ) {
            dataBindingTerm = dataBindingTerm
                .replace(/<#=agentName#>/g, this.options.model.agentName)
                .replace(/&lt;#=agentName#&gt;/g, this.options.model.agentName);
        }
        return dataBindingTerm;
        // FogBugs [2292] - END - Agent name and company name should be picked up dynamically as in classical widget.
    }
}
